"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.colors = exports.lightTheme = void 0;
exports.lightTheme = {
    primary: '#0c419a',
    secondary: '#007fad',
    accent: '#2576cd',
    success: '#009688',
    error: '#b00000',
    warning: '#785912'
};
exports.colors = __assign(__assign({}, exports.lightTheme), { pro: '#ef6c00' });
